<template>
    <div>
        <p v-if="delivery_time === null">Molimo vas sačekajte nekoliko trenutaka. Vaša poružbina se obrađuje...</p>
        <p v-else>Vaša porudžbina je potvrđena i biće na vašoj adresi za {{delivery_time}} minuta.</p>
    </div>
</template>

<script>

    const confirmation_api = window.APP_URL + '/api/placanje/potvrda';

    export default {
        data: function () {
            return {
                interval: null,
                delivery_time: null,
            };
        },
        methods: {
            confirmation_check: function () {
                axios.get(confirmation_api)
                    .then(response => {
                        this.delivery_time = response.data.delivery_time;
                        if (this.delivery_time !== null) {
                            clearInterval(this.interval);
                        }
                    });
            }
        },
        created: function () {
            this.interval = setInterval(() => {
                this.confirmation_check();
            }, 5000);
        }
    };
    
</script>
